import React from 'react';
import {
  Button,
  CardActions,
  CardContent, CardMedia, Card as MaterialCard, Typography,
} from '@mui/material';

function Card({
  image, title, description, heightImage, widthImage, textButton, onClick,
}) {
  return (
    <MaterialCard sx={{ width: '100%', maxWidth: 600, p: 2 }}>
      <CardMedia
        sx={{ height: heightImage || 280, width: widthImage, m: 'auto' }}
        image={image}
      />
      <CardContent>
        <Typography gutterBottom textAlign="center" variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={onClick}
          sx={{
            borderRadius: 8,
            textTransform: 'none',
            backgroundColor: '#00E466',
            color: '#003914',
            '&:hover': {
              backgroundColor: '#B7FFBD',
            },
          }}
          variant="contained"
          size="medium"
        >
          {textButton}
        </Button>
      </CardActions>
    </MaterialCard>
  );
}

export default Card;
